"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignItems = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.alignItems = type_guard_1.enums(['normal', 'stretch', 'center', 'start', 'end', 'flex-start', 'flex-end', 'baseline']);
